export const INTEREST_LABELS = {
  regular: "Regular purchases",
  specific: "Specific vehicles",
  selling: "Selling vehicles",
  other: "Other",
  vehicle: "Listed vehicle",
};

export const STATUS_STYLES = {
  new: "border-blue-200 bg-blue-50 text-[#1F63E0]",
  contacted: "border-blue-200 bg-blue-50 text-[#0A2540]",
  closed: "border-slate-200 bg-slate-100 text-slate-600",
};

export const fmtDate = (iso) =>
  new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
